module.exports = __webpack_public_path__ + "/login_ui/img/de-ee60489447c7e93b4c05010c7600d1d7.svg";